export default __webpack_public_path__ + "static/media/InsideSkinHairNails_04.4767bec2.png";